'use client';

import useSoftpullModalEvents from './useSoftpullModalEvents';

export default function SoftpullModalEvents() {
  useSoftpullModalEvents();

  return null;
}
